import CommunityInput from './CommunityInput';

export default CommunityInput;
